import React from "react";
import { useParams } from "react-router-dom";
import CustomLayout from "../Layout/CustomLayout";
import PharmacySideMenu from "../Layout/CustomLayout/PharmacySideMenu";
import PharmacyDashboard from "./Dashboard/PharmacyDashboard";
import PharmacyAnalytics from "./Analytics/PharmacyAnalytics";
import Configurations from "./Configurations/Configurations";
import Medicines from "./Medicines/Medicines";
import PurchaseOrderList from "./PurchaseOrders/PurchaseOrderList";
import PurchaseEntryList from "./PurchaseEntry/PurchaseEntryList";
import PurchaseReturnList from "./PurchaseReturns/PurchaseReturnList";
import PharmacyUsers from "./Users/PharmacyUsers";
import Orders from "./Orders/Orders";
import Billing from "./Billing/Billing";
import StockOut from "./StockOut/StockOut";
import Returns from "./Returns/Returns";
import PharmacyGlobalSearch from "./common/PharmacyGlobalSearch";

const Pharmacy = () => {
  const query = useParams();

  if (query?.tab === "billing") {
    return <Billing />;
  }

  const renderContent = () => {
    switch (query?.tab) {
      case "dashboard":
        return <PharmacyDashboard />;
      case "analytics":
        return <PharmacyAnalytics />;
      case "configurations":
        return <Configurations />;
      case "orders":
        return <Orders />;
      case "medicines":
        return <Medicines />;
      case "stock-out":
        return <StockOut />;
      case "purchase-order":
        return <PurchaseOrderList />;
      case "purchase-entry":
        return <PurchaseEntryList />;
      case "purchase-return":
        return <PurchaseReturnList />;
      case "users":
        return <PharmacyUsers />;
      case "returns":
        return <Returns />;
      default:
        return <PharmacyDashboard />;
    }
  };

  return (
    <CustomLayout
      headerSearch={<PharmacyGlobalSearch />}
      layoutClassName="reception-layout pharmacy-motion"
      sideContent={<PharmacySideMenu />}
      header={
        <></>
      }
    >
      {renderContent()}
    </CustomLayout>
  );
};

export default Pharmacy;
